import { render } from "./field.vue?vue&type=template&id=263a568b"
import script from "./field.vue?vue&type=script&lang=ts"
export * from "./field.vue?vue&type=script&lang=ts"
script.render = render

export default script